import styled, { css } from 'styled-components'
import Icon from '@chegg-wt/core/components/Icon'
import { Heading4 } from '@chegg/fanta'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'

export const ErrorContainer = styled.div`
  margin-top: ${FantaTheme.spacing.fanta.md};
`
export const RedContainer = styled.div`
  display: flex;
  padding: ${FantaTheme.spacing.fanta.md};
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor09};
`

export const IconCss = css`
  width: 100px;
  height: 60px;
  margin-right: ${FantaTheme.spacing.fanta.md};
`

export const RedExclamationPoint = styled(Icon)`
  ${IconCss};
  color: ${({ theme }) => theme.Colors.colorError};
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ErrorHeader = styled(Heading4)``

export const ErrorDescription = styled.span`
  line-height: ${FantaTheme.font.text.size.lg};
`

export const Link = styled.a`
  text-decoration: none;
  color: ${FantaTheme.colors.link};
  font-weight: ${FantaTheme.font.weight.bold};
`
